import {
  FEES_WITHDRAWING_ETHER_START,
  FeesActionTypes,
  FEES_WITHDRAWING_ETHER_END,
  FEES_WITHDRAWING_TOKEN_START,
  FEES_WITHDRAWING_TOKEN_END,
} from '../../types/actions/Fees.actions';

export interface FeesState {
  isWithdrawingToken: boolean;
  isWithdrawingEther: boolean;
}

const initialExchanges: FeesState = {
  isWithdrawingToken: false,
  isWithdrawingEther: false,
};

export default (state = initialExchanges, action: FeesActionTypes) => {
  switch (action.type) {
    case FEES_WITHDRAWING_ETHER_START:
      return {...state, isWithdrawingEther: true};
    case FEES_WITHDRAWING_ETHER_END:
      return {...state, isWithdrawingEther: false};

    case FEES_WITHDRAWING_TOKEN_START:
      return {...state, isWithdrawingToken: true};
    case FEES_WITHDRAWING_TOKEN_END:
      return {...state, isWithdrawingToken: false};

    default:
      return state;
  }
};
